"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractElasticSearchData = exports.extractData = void 0;
var axios_1 = require("axios");
var abstract_service_1 = require("./abstract.service");
var ServiceProvider = /** @class */ (function () {
    function ServiceProvider() {
        this.httpConfig = {};
        this.http = axios_1.default.create(this.httpConfig);
        this.esApiHttpConfig = {};
        this.esApiHttp = axios_1.default.create(this.esApiHttpConfig);
        this.addaJetApiHttpConfig = {};
        this.addaJetHttp = axios_1.default.create(this.addaJetApiHttpConfig);
        this.get = abstract_service_1.get;
        this.post = abstract_service_1.post;
        this.put = abstract_service_1.put;
        this.delete = abstract_service_1._delete;
    }
    ServiceProvider.prototype.setContentApiPath = function (value) {
        this.httpConfig.baseURL = value;
        this.recreateHttp();
    };
    ServiceProvider.prototype.setElasticsearchApiPath = function (value) {
        this.esApiHttpConfig.baseURL = value;
        this.esApiHttp = axios_1.default.create(this.esApiHttpConfig);
    };
    ServiceProvider.prototype.setAddaJetApiPath = function (value) {
        this.addaJetApiHttpConfig.baseURL = value;
        this.addaJetHttp = axios_1.default.create(this.addaJetApiHttpConfig);
    };
    ServiceProvider.prototype.recreateHttp = function () {
        this.http = axios_1.default.create(this.httpConfig);
    };
    return ServiceProvider;
}());
function extractData(response) {
    // @ts-ignore
    return response.data.data || response.data;
}
exports.extractData = extractData;
// todo
function extractElasticSearchData(response) {
    // @ts-ignore
    return response.data.hits || response.data; // TODO
}
exports.extractElasticSearchData = extractElasticSearchData;
exports.default = new ServiceProvider();
